import { wxShare } from '@/api/ebiz/common/common.js'
var wx = require('weixin-js-sdk')
//微信分享
export function weixinShare(options, that) {
  let localURl = location.href.split('#')[0]
  wxShare({ url: localURl }).then(response => {
    if (response.result == '0') {
      let data = response.content
      if (typeof data == 'string') {
        data = JSON.parse(data)
      }
      wx.config({
        // debug: true,
        appId: data.appid,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        // jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateAppMessageShareData', 'updateTimelineShareData']
        jsApiList: ['onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems', 'onMenuShareTimeline', 'updateTimelineShareData', 'updateAppMessageShareData']
      })
      wx.ready(function() {
        wx.showMenuItems({
          menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline']
        })
        wx.onMenuShareTimeline({
          title: options.title ? options.title : '',
          desc: options.desc ? options.desc : '',
          link: options.link ? options.link : '',
          imgUrl: options.imgUrl ? options.imgUrl : '',
          success: options.success ? options.success : '',
        })
        wx.onMenuShareAppMessage({
          itle: options.title ? options.title : '',
          desc: options.desc ? options.desc : '',
          link: options.link ? options.link : '',
          imgUrl: options.imgUrl ? options.imgUrl : '',
          success: options.success ? options.success : '',
        })
      })
    }
  })
}

//禁止微信分享
export function weixinShareNo() {
  let localURl = location.href.split('#')[0]
  wxShare({ url: localURl }).then(response => {
    if (response.result == '0') {
      let data = response.content
      if (typeof data == 'string') {
        data = JSON.parse(data)
      }
      wx.config({
        appId: data.appid,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ['hideMenuItems','hideOptionMenu']
      })
      wx.ready(function() {
        wx.hideOptionMenu()
      })
    }
  })
}